<template>
    <select class="mt-2 badge badge-secondary text-center" @change="changed">
        <option class="text-center" value="all" :selected="showWebshops && showLocals">Ehandel + Lokala</option>
        <option value="webshops" :selected="showWebshops && !showLocals">Visa enbart E-Handel</option>
        <option value="locals" :selected="!showWebshops && showLocals">Visa enbart Lokala</option>
    </select>
</template>

<script>
export default {
    data () {
        return {
            companyTypeFiltering: 'all',
        }
    },

    props: {
        showWebshops: {
            type: Boolean,
            default: true
        },

        showLocals: {
            type: Boolean,
            default: true
        },
    },

    methods: {
        changed (e) {
            const locals = this.showLocals;
            const webshops = this.showWebshops;

            if (e.target.value === 'all') {
                this.webshops = true;
                this.locals = true;
            } else if (e.target.value === 'webshops') {
                this.webshops = true;
                this.locals = false;
            } else if (e.target.value === 'locals') {
                this.webshops = false;
                this.locals = true;
            }

            this.$emit('update:showLocals', this.locals);
            this.$emit('update:showWebshops', this.webshops);
            this.$emit('changed');
        }
    }
}
</script>
